import React from "react";
import DataList from "components/datatable/DataList";
import { useAuth } from "context/AuthProvider";
import { showEmpty } from "features/kms/system/SystemPageUtils";

export default function CaborRekapitulasiPage() {
  const { user } = useAuth();
  const groupName = String(user?.groupname || "").toUpperCase();
  const isAdminProvinsi = groupName === "ADMIN_KONI_PROVINSI";
  const jumlahColumns = [
    ...(isAdminProvinsi ? ["jml_induk_organisasi", "jml_cabor"] : []),
    "jml_klub",
    "jml_pengurus",
    "jml_atlet",
    "jml_pelatih",
    "jml_wasit",
    "jml_juri",
    "jml_manajer",
    "jml_mekanik",
    "jml_official",
  ];
  const jumlahHeaderGroups = [{ label: "Jumlah", columns: jumlahColumns }];
  const numberCol = (label, width = 62, pdfwidth = 8) => ({
    label: `Jumlah ${label}`,
    headerLabel: label,
    renderFunc: (val) => showEmpty(val, "0"),
    renderExportFunc: (val) => showEmpty(val, "0"),
    width,
    align: "center",
    pdfwidth,
  });
  const coltype = {
    no: { label: "No.", width: 48, align: "center", pdfwidth: 5 },
    id_rekapitulasi_cabor: { type: "hidden", name: "id_rekapitulasi_cabor" },
    koni_kabkota_name: {
      label: "KONI Kab/Kota",
      renderFunc: (val) => showEmpty(val),
      width: 300,
      pdfwidth: 38,
    },
    induk_organisasi_name: {
      label: "Induk Organisasi",
      renderFunc: (val) => showEmpty(val),
      width: 240,
      pdfwidth: 35,
    },
    cabor_name: {
      label: "Cabor",
      renderFunc: (val) => showEmpty(val),
      width: 260,
      pdfwidth: 40,
    },
    jml_induk_organisasi: numberCol("Induk Organisasi", 90, 10),
    jml_cabor: numberCol("Cabor", 62),
    jml_klub: numberCol("Klub", 58),
    jml_pengurus: numberCol("Pengurus", 72, 10),
    jml_atlet: numberCol("Atlet", 58),
    jml_pelatih: numberCol("Pelatih"),
    jml_wasit: numberCol("Wasit", 58),
    jml_juri: numberCol("Juri", 54),
    jml_manajer: numberCol("Manajer", 68),
    jml_mekanik: numberCol("Mekanik", 68),
    jml_official: numberCol("Official", 68),
  };
  const columns = isAdminProvinsi
    ? ["no", "koni_kabkota_name", ...jumlahColumns]
    : ["no", "induk_organisasi_name", "cabor_name", ...jumlahColumns];
  const sortBy = isAdminProvinsi
    ? ["koni_kabkota_name"]
    : ["induk_organisasi_name", "cabor_name"];

  return (
    <DataList
      title="Rekapitulasi"
      coltype={coltype}
      dlist={{
        url: "/data-cabor/rekapitulasi",
        columns,
        headerGroups: jumlahHeaderGroups,
        filter: [{ dtype: "q", name: "q", colsize: 3 }],
        sort_by: sortBy,
      }}
      pdflist={{
        title: "Rekapitulasi Data Cabang Olahraga",
        columns,
        headerGroups: jumlahHeaderGroups,
      }}
      xlslist={{
        title: "Rekapitulasi Data Cabang Olahraga",
        columns,
        headerGroups: jumlahHeaderGroups,
      }}
      pdfconfig={{ orientation: "landscape" }}
    />
  );
}
